class EventEmitter {
  subscribers = {}

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  subscribe(event, callback) {
    // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
    if (!this.subscribers[event]) {
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      this.subscribers[event] = []
    }
    // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
    this.subscribers[event].push(callback)
  }

  clear() {
    this.subscribers = {}
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  unsubscribe(event, callback) {
    // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
    if (this.subscribers[event]) {
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      this.subscribers[event] = this.subscribers[event].filter((subscriber) => subscriber !== callback)
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  emit(event, data) {
    // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
    if (this.subscribers[event]) {
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      this.subscribers[event].forEach((subscriber) => subscriber(data))
    }
  }
}

export const eventEmitter = new EventEmitter()
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
export const successEventEmitterMiddleware = (store) => (next) => (action) => {
  const emitEvent = action?.extraData?.emitEvent
  const emitEventData = action?.extraData?.emitEventData
  const emitData = action?.extraData?.emitData

  if (emitEvent) {
    eventEmitter.emit(emitEvent, emitEventData ?? (emitData === 'status' ? action.failed : true))
  }

  next(action)
}
